// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Prompt: MarkdocTagRegistration = {
  tag: 'prompt',
  component: 'Prompt',
  attributes: {
    apiKey: {type: String},
    type: {type: String},
    desiredShape: {type: String},
    sticky: {type: String, localize: true},
    account: {type: Object},
  },
};
